import React from "react";
import Header from "./components/header"
import Body from "./components/body"

function Staff () {
    return (
        <div>
            <title>Our Staff | PaladiumTechServiceLimited</title>
            <Header />
            <Body />
        </div>
    )
}

export default Staff;